export default __webpack_public_path__ + "static/media/gallery-9-3.2b6b9634.jpg";